import { forwardRef } from "react";
import { Link } from "react-router-dom";
import { NavigationAnchor } from "@/components/layout/types";

interface NavigationItemProps {
  item: Omit<NavigationAnchor, "permission">;
  className?: string;
  iconClassName?: string;
}

export const NavigationItem = forwardRef<
  HTMLAnchorElement,
  NavigationItemProps
>(({ item, className, iconClassName, ...props }, ref) => {
  return (
    <Link to={item.url} ref={ref} className={className} {...props}>
      <item.icon className={iconClassName} />
      <span>{item.title}</span>
    </Link>
  );
});
